import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addCustomer = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Customer', body);
  return data;
});
export const updateCustomer = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Customer/${id}`,
    body
  );
  return data;
});

export const getCustomer = catchAsync(async ({ key = '', value = '' }) => {
  // '/api/resource/Customer?fields=["name","customer_name_in_arabic","tax_id","customer_name","customer_type","custom_email","customer_group","territory","default_bank_account"]&order_by=name desc&limit_start=0&limit_page_length=0';
  let baseUrl =
    '/api/resource/Customer?fields=["name","tax_id","customer_name","customer_type","custom_email","customer_group","territory","default_bank_account"]&order_by=name desc&limit_start=0&limit_page_length=0';
  if (value) {
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(baseUrl);
  return data;
});
export const deleteCustomer = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Customer/${record}`
  );
  return data;
});
export const getCustomerById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Customer/${id}`);
  return data;
});
export const getCustomerData = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_data?type=Company&name=${id}&fields=["default_receivable_account","cost_center"] `
  );
  return data;
});

export const getCustomerListDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Customer/${id}`);
  return data;
});
